import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { map, catchError, } from 'rxjs/operators';
import { throwError, Observable, BehaviorSubject, of } from 'rxjs';
import { CredentialsService } from './credentials.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

// export interface SignupContext {
//   program: string;
//   companyName: string;
//   companyUrl: string;
//   salutaion: string;
//   firstName: string;
//   middleName: string;
//   lastName: string;
//   phone: string;
//   email: string;
//   password: string;
// }

// export interface LoginContext {
//   email: string;
//   password: string;
//   roles: string;
//   remember: string;
// }

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private _baseUrl = environment.url;

  constructor(
    private credentialsService: CredentialsService,	private router: Router,
    private httpClient: HttpClient) {

  }

  /**
* @method
* @name login
* @description
* Authenticates the user.
* Request body:json {
       'email': string,
       'password': string
* }
* @param context The login parameters.
* @return Promise.
*/
  login(context) {
    return this.httpClient.post(this._baseUrl + `adminSignin`, context).pipe(
      map((response: any) => {
        this.credentialsService.setCredentials(response.data);
        return response;
      }),
      catchError(this.handleError)
    );
  }

  Signup(context) {
    return this.httpClient.post(this._baseUrl + `user/register`, context).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(this.handleError)
    )

  }

  sendEmailForSecurityAnswer(param?) {
    let params = this.getParams(param)
    return this.httpClient.get(this._baseUrl + 'getSecurityAnswer', { params: params }).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(this.handleError)
    )
  }

  logout() {
    this.credentialsService.logout().subscribe(res => {
      this.router.navigate(['/']);
    });
  }

  changePass(params) {
    let param = this.getParams(params);
    return this.httpClient.post(this._baseUrl + 'changePassword', param).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(this.handleError)
    )
  }

  resetPasswordWithEmail(context) {
    return this.httpClient.put(this._baseUrl + `resetPasswordWithEmail`, context).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(this.handleError)
    )
  }

  sendEmail(formData): Observable<any> {
    return this.httpClient.post(this._baseUrl + `forgotpassword`, formData).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(this.handleError)
    )
  }

  autoLogin(context) {
    return this.httpClient.post(this._baseUrl + 'autoLogin', context).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(this.handleError)
    )
  }

  resetPassword(formData): Observable<any> {
    return this.httpClient.put(this._baseUrl + `resetPassword`, formData).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(this.handleError)
    )
  }

  getDetailWithId(param?) {
    let params= this.getParams(param)
    return this.httpClient.get(this._baseUrl + 'userDetail', { params: params }).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(this.handleError)
    )
  }


  getParams(parameters) {
    let params = new HttpParams();
    Object.keys(parameters).map((key) => {
      params = params.set(key, parameters[key]);
    })
    return params;
  }

  handleError(error: HttpErrorResponse) {
    if (error.error.code == 401) {
      return throwError('');
    } else if (error.error.code == 404) {
      return throwError(error.error.message);
    }else if (error.error.code == 400) {
      return throwError(error.error.message);
    }
    return throwError(
      'Something bad happened; please try again later.');
  }
}
